module.exports = __webpack_public_path__ + "static/img/memberWYF.9beb487.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investTeam/memberWYF.png
// module id = 2Iat
// module chunks = 0